import { OwnerRole } from "../../models/enums";
var Constants = /** @class */ (function () {
    function Constants() {
        Object.defineProperty(this, "companyTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                {
                    id: 1,
                    value: 'Limited'
                },
                {
                    id: 2,
                    value: 'Public Limited'
                },
                {
                    id: 3,
                    value: 'Corporation'
                },
                {
                    id: 4,
                    value: 'Limited Liability Partnership'
                },
                {
                    id: 5,
                    value: 'Govermment/Local Authority'
                },
                {
                    id: 6,
                    value: 'Sole Trader'
                },
                {
                    id: 7,
                    value: 'Partnership'
                },
                {
                    id: 8,
                    value: 'Other'
                }
            ]
        });
        Object.defineProperty(this, "operatingTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                { key: 'officeSuite', value: 'Office Suite' },
                { key: 'retail', value: 'Retail storefront' },
                { key: 'warehouse', value: 'Warehouse' },
                { key: 'privateSector', value: 'Private Sector' }
            ]
        });
        Object.defineProperty(this, "organizationalRoles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                { key: OwnerRole.Director, value: 'Director' },
                { key: OwnerRole.DirectorAndOwner, value: 'Director & Owner' },
                { key: OwnerRole.UBO, value: 'UBO' },
                { key: OwnerRole.Shareholder, value: 'Shareholder' },
                { key: OwnerRole.Regular, value: 'Regular' }
            ]
        });
        Object.defineProperty(this, "pricingModel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: [
                { key: "None", value: "None" },
                { key: "One-Off", value: "One-off" },
                { key: "Recurring", value: "Recurring" },
                { key: "Other", value: "" }
            ]
        });
    }
    return Constants;
}());
export { Constants };
